"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LineOfCoverageLineageCommandStatusReason = exports.LineOfCoverageLineageCommandStatus = exports.LineOfCoverageLineageCommandType = void 0;
var LineOfCoverageLineageCommandType;
(function (LineOfCoverageLineageCommandType) {
    LineOfCoverageLineageCommandType["CREATE"] = "CREATE";
    LineOfCoverageLineageCommandType["DELETE"] = "DELETE";
})(LineOfCoverageLineageCommandType = exports.LineOfCoverageLineageCommandType || (exports.LineOfCoverageLineageCommandType = {}));
var LineOfCoverageLineageCommandStatus;
(function (LineOfCoverageLineageCommandStatus) {
    LineOfCoverageLineageCommandStatus["COMPLETED"] = "COMPLETED";
    LineOfCoverageLineageCommandStatus["NO_OPERATION"] = "NO_OPERATION";
    LineOfCoverageLineageCommandStatus["PENDING"] = "PENDING";
})(LineOfCoverageLineageCommandStatus = exports.LineOfCoverageLineageCommandStatus || (exports.LineOfCoverageLineageCommandStatus = {}));
var LineOfCoverageLineageCommandStatusReason;
(function (LineOfCoverageLineageCommandStatusReason) {
    LineOfCoverageLineageCommandStatusReason["DUPLICATE"] = "DUPLICATE";
    LineOfCoverageLineageCommandStatusReason["FAILED"] = "FAILED";
    LineOfCoverageLineageCommandStatusReason["NO_OPERATION"] = "NO_OPERATION";
    LineOfCoverageLineageCommandStatusReason["RESTORED"] = "RESTORED";
    LineOfCoverageLineageCommandStatusReason["SUCCESSFUL"] = "SUCCESSFUL";
})(LineOfCoverageLineageCommandStatusReason = exports.LineOfCoverageLineageCommandStatusReason || (exports.LineOfCoverageLineageCommandStatusReason = {}));
//# sourceMappingURL=line-of-coverage-lineage-command.js.map